import React from 'react';
import { useRoutes, Navigate, Routes, Route } from 'react-router-dom';
import { publicRoutes } from './public';
import { protectedRoutes } from './protected';
import { websiteRoutes } from './website';
import { paths, ROOT_PATHS } from './paths';
import { useAuth } from 'lib/auth';
import { PublicProfile } from 'features/companies';
import { MembershipPending } from 'features/auth/components/MembershipPending';
import { AcceptInvitation } from 'features/auth/routes/AcceptInvitation';
import { RequestAccessForm } from 'features/auth/components/RequestAccessForm';
import { AccessRequested } from 'features/auth/components/AccessRequested';
import { JoinCompany } from 'features/auth/components/JoinCompany';
import { Logout } from './Logout';
import { SignedOutRedirect } from './SignedOutRedirect';
import { peekReturnTo } from 'lib/returnTo';

export * from './paths';

const pendingRoutes = [
  {
    path: '/app',
    children: [
      { path: ROOT_PATHS.REQUEST_ACCESS, element: <RequestAccessForm /> },
      { path: ROOT_PATHS.ACCESS_REQUESTED, element: <AccessRequested /> },
      { path: ROOT_PATHS.JOIN_COMPANY, element: <JoinCompany /> },
      { path: ROOT_PATHS.LOGOUT, element: <Logout /> },
      { path: '*', element: <MembershipPending /> },
    ],
  },
];

export const AppRoutes = () => {
  const { account, user } = useAuth();
  const hasPendingAccessOnly = account && !account.super_admin && !user;

  const commonRoutes = [
    {
      path: paths.auth.acceptInvitation,
      element: <AcceptInvitation />,
    },
    {
      path: '/auth/*',
      element: <Navigate to={account ? peekReturnTo() ?? paths.homepage : ROOT_PATHS.WEBSITE} replace={true} />,
    },
    {
      path: '/*',
      element: account ? <Navigate to={hasPendingAccessOnly ? paths.homepage : /* account ? paths.frameworkAgreement : */ ROOT_PATHS.WEBSITE} replace={true} /> : <SignedOutRedirect />,
    },
  ];
  const routes = hasPendingAccessOnly ? pendingRoutes : account ? protectedRoutes : publicRoutes;
  const element = useRoutes([...routes, ...websiteRoutes, ...commonRoutes]);  

  return <>{element}</>;
};

export const PublicProfileRoutes = () => {
  return (
    <Routes>
      <Route path={"/"} element={<PublicProfile />} />
    </Routes>
  );
}
